"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExponentiationNode = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'EXPONENTIATION';
class ExponentiationNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            var _a;
            const base = Number(params.base);
            const power = Number(params.power);
            if (lodash_1.default.isNaN(base) || lodash_1.default.isNaN(power)) {
                return { result: undefined };
            }
            const result = (_a = Math.pow(base, power)) !== null && _a !== void 0 ? _a : undefined;
            return { result };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.ExponentiationNode = ExponentiationNode;
ExponentiationNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Exponentiation',
    isIdempotent: true,
    primaryCategory: 'Math',
};
//# sourceMappingURL=Exponentiation.js.map